import { CommonModule, DOCUMENT, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Input, NgModule, Output, TemplateRef } from '@angular/core';
import { IFullScreenDocument, ModalOptions } from '../../models';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, CommonModule, NgTemplateOutlet]
})
export class ModalWrapperComponent {
  @Input() options: ModalOptions = new ModalOptions();
  @Input() isValid: boolean = true;
  @Input() buttonTemplate!: TemplateRef<any>;

  @Output() isValidChange = new EventEmitter<boolean>();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  isFullScreen: boolean = false;
  elem: any;

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  fullscreenmodes(_event: any) {
    this.chkScreenMode();
  }

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.elem = document.documentElement;
  }

  public onSave() {
    // If fullsize close down
    if (this.isFullScreen) {
      this.closefullscreen();
    }
    this.save.emit('Save Clicked');
  }

  public onCancel(reason: string) {
    // If fullsize close down
    if (this.isFullScreen) {
      this.closefullscreen();
    }
    this.cancel.emit(reason);
  }

  chkScreenMode() {
    if (document.fullscreenElement) {
      //fullscreen
      this.isFullScreen = true;
      // Toggle css class
      this.document.querySelector('.modal-dialog')!.classList.add('modal-fullscreen');
    }
    else {
      //not in full screen
      this.isFullScreen = false;
      // Toggle css class
      this.document.querySelector('.modal-dialog')!.classList.remove('modal-fullscreen');
    }
  }

  openfullscreen() {
    // fire open fullscreen mode
    this.openFullScreenMode();

  }

  closefullscreen() {
    // Fire close fullscreen mode
    this.closeFullScreenMode();
  }

  private openFullScreenMode() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  private closeFullScreenMode() {
    const doc = this.document as IFullScreenDocument;
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      /* Firefox */
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) {
      /* IE/Edge */
      doc.msExitFullscreen();
    }
  }
}
